// @ts-nocheck
import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle, ShieldCheck } from 'lucide-react';

interface Props {
  eventId: string;
  className?: string;
}

export default function EventVerificationNotice({ eventId, className = '' }: Props) {
  const [settings, setSettings] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!eventId) return;
    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        const { data, error } = await (supabase as any).rpc('get_event_verification_settings', {
          p_event_id: eventId,
        });
        if (cancelled) return;
        if (error) {
          console.error('Failed to load event verification settings:', error);
          setSettings(null);
        } else {
          setSettings(data || null);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('Failed to load event verification settings:', err);
          setSettings(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  if (loading || !settings?.enabled) return null;

  const isBlock = settings.mode === 'block';

  return (
    <Alert
      className={`${className} ${
        isBlock
          ? 'bg-red-50 border-red-200 text-red-900'
          : 'bg-amber-50 border-amber-200 text-amber-900'
      }`}
    >
      {isBlock ? (
        <AlertTriangle className="h-5 w-5 text-red-700" />
      ) : (
        <ShieldCheck className="h-5 w-5 text-amber-700" />
      )}
      <AlertTitle className="font-semibold">
        Player verification required
      </AlertTitle>
      <AlertDescription className="mt-1">
        This event requires player age verification. Each rostered player must be verified before check-in.
        {isBlock && (
          <span className="block mt-1 font-medium">
            Unverified players cannot check in.
          </span>
        )}
      </AlertDescription>
    </Alert>
  );
}
